import styled from "styled-components";
import { Box } from "../../components/common/Box";

export const UsersContainer = styled.div`
    width: 100%;
    max-height: 100%;
    overflow:  auto;
`